/**
 * Global Lotus AI configuration.
 * This object can injected into the page via ASP.NET.
 * It can be extended from withing .js though.
 */
const config = {
	logoutRootRelativePath: "/logout",
	loginRootRelativePath: "/login",

	forgotPasswordRootRelativePath: "/forgot-password",
	resetPasswordRootRelativePath: "/reset-password",

	defaultPathAfterSuccessfulLogin: "/",

	api: {
		baseUrl: {
			//development: "https://localhost:44393",	// .NET 4.7.2
			development: "https://localhost:7222",		// .NET 9
				//-- So I don't have to run up API in development
				//development: "https://lotusai-test-api.azurewebsites.net",
				//development: "https://api.lotusai.co",
			

			//test: "https://test.api.lotusai.co",	// Via reverse proxy
			test: "https://lotusai-test-api-2-fue9bzbccahkatbd.australiaeast-01.azurewebsites.net",	// .NET 9



			//production: "https://api.lotusai.co",
			production: "https://lotusai-prod-portal-api-2-bpezeqgfehfte2dp.australiaeast-01.azurewebsites.net",	// .NET 9


			
			production2: "https://api.lotusai.co", // Azure backup portal
			//production2: "https://lotusai-prod-portal-api-2-bpezeqgfehfte2dp.australiaeast-01.azurewebsites.net",	// .NET 9



			//alpha: "https://alpha.api.lotusai.co",
			alpha: "https://lotusai-alpha-api-2-add3decgdrc0hahx.australiaeast-01.azurewebsites.net",	// .NET 9


			demo: "https://lotusai-test-api-2-fue9bzbccahkatbd.australiaeast-01.azurewebsites.net",	// .NET 9
		}
	},

	filesApi: {
		baseUrl: {
			development: "https://localhost:7062",

			//-- So I don't have to run up API in development
			//development: "https://files.api.lotusai.co",

			test: "https://lotusai-test-files-api.azurewebsites.net",
			
			production: "https://files.api.lotusai.co",

			// alpha: "https://files.api.lotusai.co"
			alpha: "https://lotusai-alpha-api-2-add3decgdrc0hahx.australiaeast-01.azurewebsites.net",


			demo: "https://lotusai-test-files-api.azurewebsites.net",
		}
	},



	modules: {
		valenHr: {
			//NOTE: Originally called "Valen HR". Renamed to "Staff HR" for better visibility with potential customers.
			//displayName: "Valen HR"
			displayName: "Staff HR",

			//routePath: "valen-hr",
			routePath: "staff-hr"
		}
	},

	logo: {
		standardFullSizeUrl: "https://lotusai.co/wp-content/uploads/2022/05/logo_white.svg",
		imageOnlyFullSizeUrl: "https://assets.lotusai.co/portal/images/logo-gold-transparent.png",
	},


	/**
	   * Return the base URL to the primary Lotus back-end API for the current envrionment.
	   */
	GetLotusApiBaseUrl()
	{
		const environment = this.GetEnvironmentCode();

		const url = this.api.baseUrl[environment];

		if (environment == "unknown" || url == undefined)
		{
			console.error("Config::GetLotusApiBaseUrl(" + environment + "): Something went wrong. Unknown environment. url=", url);
		} else
		{
			//console.log("Config::GetLotusApiBaseUrl(" + environment + "): url=", url);
			//console.log("Config::GetLotusApiBaseUrl()->getCurrentDomain()=", this.getCurrentDomain());
		}

		return url;
	},

	/**
	   * Return the base URL to the Lotus "Files" back-end API for the current envrionment.
	   */
	GetLotusFilesApiBaseUrl()
	{
		const environment = this.GetEnvironmentCode();

		const url = this.filesApi.baseUrl[environment];

		if (environment == "unknown" || url == undefined)
		{
			console.error("Config::GetLotusFilesApiBaseUrl(" + environment + "): Something went wrong. Unknown environment. url=", url);
		} else
		{
			//console.log("Config::GetLotusFilesApiBaseUrl(" + environment + "): url=", url);
			//console.log("Config::GetLotusFilesApiBaseUrl()->getCurrentDomain()=", this.getCurrentDomain());
		}

		return url;
	},

	/**
	   * Check if the current environment is "Production".
	   * 
	   * @returns bool
	   */
	IsProduction()
	{
		if (
			this.getCurrentDomain() == "portal.lotusai.co" ||
			this.getCurrentDomain() == "lotusai.co" || 

			this.getCurrentDomain() == "client-portal.lotusai.co" ||
			this.getCurrentDomain() == "lotus-client-portal-production.netlify.app"
		)
		{
			return true;
		}

		return false;
	},

	// Azure backup production portal
	IsProduction2()
	{
		if (
			this.getCurrentDomain() == "nice-pebble-0ed7bac00.6.azurestaticapps.net"
		)
		{
			return true;
		}

		return false;
	},

	IsProductionAlpha()
	{
		if (
			this.getCurrentDomain() == "alpha.portal.lotusai.co" ||
			this.getCurrentDomain() == "lotus-portal-production-alpha.netlify.app"
		)
		{
			return true;
		}

		return false;
	},


	/**
	   * Check if the current environment is "Test".
	   * 
	   * @returns bool
	   */
	IsTest()
	{
		if (
			this.getCurrentDomain() == "test.portal.lotusai.co" ||
			this.getCurrentDomain() == "lotus-portal-test.netlify.app" ||
			this.getCurrentDomain() == "lotus-portal-test2.netlify.app" ||
			this.getCurrentDomain() == "lotusai-test-tessta.netlify.app" || 
			this.getCurrentDomain() == "lotusai-test-bizfury.netlify.app"
		)
		{
			return true;
		}

		return false;
	},


	IsDemo()
	{
		if (
			this.getCurrentDomain() == "demo.portal.lotusai.co" ||
			this.getCurrentDomain() == "lotus-portal-demo.netlify.app"
		)
		{
			return true;
		}

		return false;
	},

	/**
	   * Check if the current environment is "Development".
	   * 
	   * @returns bool
	   */
	IsDevelopment()
	{
		if (
			this.getCurrentDomain() == "localhost" ||
			this.getCurrentDomain() == "127.0.0.1"
		)
		{
			return true;
		}

		return false;
	},

	/**
	   * Return the code for the current environment.
	   * 
	   * @returns string Code of the current environment, otherwise "unknown".
	   */
	GetEnvironmentCode()
	{
		if (this.IsProduction()) return "production";
		if (this.IsProduction2()) return "production2";
		if (this.IsProductionAlpha()) return "alpha";
		if (this.IsTest()) return "test";
		if (this.IsDevelopment()) return "development";
		if (this.IsDemo()) return "demo";

		return "unknown";
	},

	GetEnvironmentName()
	{
		if (this.IsProduction()) return "Production";
		if (this.IsProduction2()) return "Production";
		if (this.IsProductionAlpha()) return "Production (Alpha)";
		if (this.IsTest()) return "Test";
		if (this.IsDevelopment()) return "Development";
		if (this.IsDemo()) return "Demo";

		return "unknown";
	},

	/**
	   * Return the "domain" component of the URL this site is running on.
	   * 
	   * @returns string
	   */
	getCurrentDomain()
	{
		return window.location.hostname;
	}
};

export default config;
